import React from "react";

// Product gallery images from assets/new
const galleryImages = [
  "/assets/new/EC76674907_Banner2.jpg",
  "/assets/new/KY22508149_mega_spice.jpg",
  "/assets/new/mega2_spices.jpg",
  "/assets/new/turmeric_powder.jpg",
  "/assets/new/bay_leaf_1.jpg",
  "/assets/new/star_anise.jpg",
];

function Gallery() {
  return (
    <div style={styles.container}>
      <h2
  style={{
    margin: "80px 0 0",
    fontFamily: "Caveat, cursive",
    fontWeight: 300,
    fontSize: "3.75rem",
    lineHeight: 1.2,
    letterSpacing: "-0.00833em",
    color: "#778A24",
    textAlign: "center",
  }}
  className="caveatFont"
>
  Product List
</h2>

      <div style={styles.grid}>
        {galleryImages.map((src, index) => (
          <div key={index} style={styles.card}>
            <img src={src} alt={`Gallery ${index}`} style={styles.image} />
          </div>
        ))}
      </div>
    </div>
  );
}

// Inline CSS styles
const styles = {
  container: {
    padding: "20px",
    textAlign: "center",
  },
  heading: {
    margin: "0",
    fontFamily: "'Caveat', cursive", // ✅ use custom font
    fontWeight: 300,
    fontSize: "3.75rem",
    lineHeight: 1.2,
    letterSpacing: "-0.00833em",
    color: "#778A24",
    marginTop: "80px",
    textAlign: "center",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)", // always 3 per row
    gap: "15px",
    marginTop: "40px",
  },
  card: {
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    transition: "transform 0.2s",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
};

export default Gallery;
